import { resolveConfidenceVisitorId } from "@helpers/confidenceVisitorId"
import { Confidence } from "@spotify-confidence/sdk"
import { redirect } from "react-router-dom"

const confidence = Confidence.create({
  clientSecret: import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string,
  environment: "client",
  region: "eu",
  timeout: 1000,
})

// Set here rather than through the SDK's visitorIdentity() tracker, which the
// loader below used to call on every run. That tracker re-read the cookie on
// each page load and minted a fresh uuid whenever it found none, so on the iOS
// in-app browsers that drop the cookie mid-document it produced a different
// randomisation unit per page view, which would quietly split any running test.
// resolveConfidenceVisitorId resolves one id per page load and prefers an
// existing one, so a returning visitor stays in the variant they were already
// served.
const visitorId = resolveConfidenceVisitorId()

if (visitorId) confidence.setContext({ visitor_id: visitorId })

export default async function getOnboardingFlagLoader() {
  const flagValue = await confidence.getFlag("cc-optimization", {
    variant: "baseline",
  })

  switch (flagValue.variant) {
    case "v1":
      return redirect("/onboarding/v1" + window.location.search)

    case "v2":
      return redirect("/onboarding/v2" + window.location.search)

    case "v3":
      return redirect("/onboarding/v3" + window.location.search)

    case "v4":
      return redirect("/onboarding/v4" + window.location.search)

    default:
      return null
  }
}
